module.exports = __webpack_public_path__ + "static/jan.786b68ec.png";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/AboutPage/PeopleSection/jan.png
// module id = 1003
// module chunks = 0